import { render } from "./AddIdea.vue?vue&type=template&id=759b6f0e"
import script from "./AddIdea.vue?vue&type=script&lang=js"
export * from "./AddIdea.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__